export enum ReportStatus {
  ALL = 'all',
  IN_PROGRESS = 'inprogress',
  FINALIZED = 'finalized',
  CANCELLED = 'cancelled'
}
